var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80459 10.193C3.54426 9.93263 3.54426 9.5105 3.80459 9.25016L7.06606 5.99187C7.58686 5.47161 8.43073 5.47181 8.95126 5.99233L12.2115 9.25257C12.4718 9.5129 12.4718 9.93503 12.2115 10.1954C11.9511 10.4558 11.529 10.4558 11.2687 10.1954L8.47826 7.40496C8.21786 7.14463 7.79579 7.14463 7.53546 7.40496L4.74739 10.193C4.48706 10.4533 4.06493 10.4533 3.80459 10.193Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/upArrowIcon.bf5dd6db566278d14b310354c77e567f.svg";
export { ForwardRef as ReactComponent };